module.exports = __webpack_public_path__ + "static/media/NAAC_banner.01053df3.jpg";